<template>
  <v-layout>
    <v-flex xs12>
      <bt-realization-form :value="realization" :title="title" :editable="editable" :approval="false"
                           :newExpenseRoute="{name: 'bt-realization-approval-new-expense'}" ref="form"
                           :expenseDetailRoute="{name: 'bt-realization-approval-expense-detail'}" @save="save"
                           v-if="loaded"/>
      <h2 v-else>Loading...</h2>
      <ApprovalD v-model="ApprovalDData" @approval="approval" />
    </v-flex>
  </v-layout>
</template>
<script>
import BtRealizationForm from './BtRealizationForm'
import Vuex from 'vuex'
import ApprovalD from '@/components/dialogs/ApprovalConfirmation'

const btRealizationStore = Vuex.createNamespacedHelpers('BusinessTripRealization/Realization')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  components: {
    BtRealizationForm,
    ApprovalD
  },
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: null
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: 'Approval Business Trip Realization',
      realization: {},
      loaded: false,
      modified: false
    }
  },
  computed: {
    ...dialogsStore.mapGetters({
      ApprovalDData: 'getApprovalD'
    })
  },
  methods: {
    ...btRealizationStore.mapActions({
      getRealization: 'getRealization',
      getRealizationExpense: 'getRealizationExpense',
      updateRealization: 'updateRealization'
    }),
    loadResources () {
      const self = this
      self.getRealization({vueinstance: self, id: self.id})
        .then(res => {
          self.realization = res.content
          self.loaded = true
        }).catch(err => self.$error(err))
    },
    approval (data) {
      const self = this

      if (data.action === 'APPROVED') {
        if (self.editable) {
          self.$refs.form.save()
          if (this.realization.expenses.length === 0) {
            self.$error('Must have Expenses(s)')
          } else {
            self.updateRealization({vueinstance: self, id: self.realization.id, sppdReal: self.realization, transmode: false})
              .then(res => {
                self.$success('Business Trip Realization ' + res.batchNo + ' updated')
                data.command()
              }).catch(err => self.$error(err))
          }
        } else {
          data.command()
        }
      } else {
        data.command()
      }
    },
    save (data) {
      this.realization = data
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealizationApproval.vue